const CONNECTED = Symbol('CONNECTED')
const DISCONNECTED = Symbol('DISCONNECTED')
const TIMED_OUT = Symbol('SOCKET_TIMED_OUT')
const REMOVED_FROM_ROOM = Symbol('REMOVED_FROM_ROOM')

const INITIAL_STATE = {
  connected: true,
  timedOut: false,
  removedFromRoom: false,
}

// Reducer

export default (state = INITIAL_STATE, action) => {
  if (action.type === CONNECTED) {
    return { ...state, connected: true }
  }

  if (action.type === DISCONNECTED) {
    return { ...state, connected: false }
  }

  if (action.type === TIMED_OUT) {
    return { ...state, timedOut: true }
  }

  if (action.type === REMOVED_FROM_ROOM) {
    return { ...state, removedFromRoom: true }
  }

  return state
}

// Actions

export const socketConnected = () => ({
  type: CONNECTED,
})

export const socketDisconnected = () => ({
  type: DISCONNECTED,
})

export const socketTimedOut = () => ({
  type: TIMED_OUT,
})

export const socketRemovedFromRoom = () => ({
  type: REMOVED_FROM_ROOM,
})

// Selectors

export const getConnected = state => {
  return state.sockets.connected
}

export const getTimedOut = state => {
  return state.sockets.timedOut
}

export const getRemovedFromRoom = state => {
  return state.sockets.removedFromRoom
}
